import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,{staticClass:"ma-1",attrs:{"close":_vm.closeable,"color":"primary","close-label":"Fermer","close-icon":"$close-line"},on:{"click":_vm.clickAction,"click:close":_vm.closeAction}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }